<template>
	<AspectTableSingleEdit />
</template>

<script>
import AspectTableSingleEdit from "@/components/AspectTable/AspectTableSingle/AspectTableSingleEdit";

export default {
	name: "AspectPageSingle",
	components: {
		AspectTableSingleEdit
	}
}
</script>

<style scoped>

</style>